'use client'

import React from 'react'
import {cn} from './cn'

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg' | 'xl'
    variant?: 'primary' | 'secondary' | 'white'
    className?: string
    'aria-label'?: string
}

const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
}

const variantClasses = {
    primary: 'text-primary',
    secondary: 'text-gray-600 dark:text-gray-400',
    white: 'text-white'
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                                  size = 'md',
                                                                  variant = 'primary',
                                                                  className = '',
                                                                  'aria-label': ariaLabel = 'Loading...'
                                                              }) => {
    return (
        <div
            className={cn(
                'animate-spin rounded-full border-2 border-current border-t-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]',
                sizeClasses[size],
                variantClasses[variant],
                className
            )}
            role="status"
            aria-label={ariaLabel}
        >
            <span className="sr-only">{ariaLabel}</span>
        </div>
    )
}

LoadingSpinner.displayName = 'LoadingSpinner'
